import {TagAuthorFilterComponent} from '../../../tags/tag-author-filter.component';
import {SmActionButtonModule} from '../sm-action-button/sm-action-button.module';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmGlobalSearchContainerResultModule} from './sm-global-search-container-result.module';
import {SmGlobalSearchItemResultModule} from './sm-global-search-item-result.module';
import {SmGlobalSearchResultsComponent} from './sm-global-search-results.component';

@NgModule({
  imports: [TagAuthorFilterComponent, SmActionButtonModule,
    CommonModule,
    IonicModule,
    SmGlobalSearchContainerResultModule,
    SmGlobalSearchItemResultModule,
  ],
  declarations: [SmGlobalSearchResultsComponent],
  exports: [SmGlobalSearchResultsComponent],
})
export class SmGlobalSearchResultsModule {}
